class FullScreenControl {
  constructor (options) {
    this.fullscreen = false;
    if (options && options.container) {
      if (options.container instanceof global.HTMLElement) {
        this.container = options.container;
      }
    }
    ['onClickFullscreen', 'changeButton'].forEach(fn => {
      if (!this[fn]) { return; }
      this[fn] = this[fn].bind(this);
    });
    if ('onfullscreenchange' in global.document) {
      this.fullscreenchange = 'fullscreenchange';
    } else if ('onmozfullscreenchange' in global.document) {
      this.fullscreenchange = 'mozfullscreenchange';
    } else if ('onwebkitfullscreenchange' in global.document) {
      this.fullscreenchange = 'webkitfullscreenchange';
    } else if ('onmsfullscreenchange' in global.document) {
      this.fullscreenchange = 'MSFullscreenChange';
    }
    this.className = 'mapboxgl-ctrl';
  }

  onAdd (map) {
    this.map = map;
    if (!this.container) this.container = this.map.getContainer();
    const el = global.document.createElement('div');
    el.className = `${this.className} mapboxgl-ctrl-group`;
    this.controlContainer = el;


    if (this.checkFullscreenSupport()) {
      this.setupUI();
    } else {
      this.controlContainer.style.display = 'none';
    }
    return this.controlContainer;
  }

  onRemove () {
    const parentControlContainer = this.controlContainer.parentNode;
    if (parentControlContainer) {
      parentControlContainer.removeChild(this.controlContainer);
    }
    this.map = null;
    global.document.removeEventListener(this.fullscreenchange, this.changeButton);
  }

  checkFullscreenSupport = () => !!(
    global.document.fullscreenEnabled ||
    global.document.mozFullScreenEnabled ||
    global.document.msFullscreenEnabled ||
    global.document.webkitFullscreenEnabled
  )

  setupUI () {
    const bt = global.document.createElement('button');
    bt.className = `${this.className}-icon ${this.className}-fullscreen`;
    this.controlContainer.appendChild(bt);
    this.fullscreenButton = bt;
    const button = this.fullscreenButton;
    const buttonLabel = this.fullscreen ? 'Enlever le mode plein écran' : 'Mettre la carte en plein écran';
    button.type = 'button';
    button.innerHTML = `<span class="mapbox-gl-draw_ctrl-draw-btn__tooltip">${buttonLabel}</span>`;
    this.fullscreenButton.addEventListener('click', this.onClickFullscreen);
    global.document.addEventListener(this.fullscreenchange, this.changeButton);
  }

  isFullscreen () {
    return this.fullscreen;
  }

  changeButton () {
    const fullscreenElement =
      global.document.fullscreenElement ||
      global.document.mozFullScreenElement ||
      global.document.webkitFullscreenElement ||
      global.document.msFullscreenElement;


    if ((fullscreenElement === this.container) !== this.fullscreen) {
      this.fullscreen = !this.fullscreen;
      const buttonLabel = this.fullscreen ? 'Enlever le mode plein écran' : 'Mettre la carte en plein écran';
      this.fullscreenButton.innerHTML = `<span class="mapbox-gl-draw_ctrl-draw-btn__tooltip">${buttonLabel}</span>`;
      this.fullscreenButton.classList.toggle(`${this.className}-shrink`);
      this.fullscreenButton.classList.toggle(`${this.className}-fullscreen`);
    }
  }

  onClickFullscreen () {
    if (this.isFullscreen()) {
      if (global.document.exitFullscreen) {
        global.document.exitFullscreen();
      } else if (global.document.mozCancelFullScreen) {
        global.document.mozCancelFullScreen();
      } else if (global.document.msExitFullscreen) {
        global.document.msExitFullscreen();
      } else if (global.document.webkitCancelFullScreen) {
        global.document.webkitCancelFullScreen();
      }
    } else if (this.container.requestFullscreen) {
      this.container.requestFullscreen();
    } else if (this.container.mozRequestFullScreen) {
      this.container.mozRequestFullScreen();
    } else if (this.container.msRequestFullscreen) {
      this.container.msRequestFullscreen();
    } else if (this.container.webkitRequestFullscreen) {
      this.container.webkitRequestFullscreen();
    }
  }
}

export default FullScreenControl;



// WEBPACK FOOTER //
// ./src/components/TerraDrawMap/FullScreenControl.js